// constants/timeWindows.ts
export enum TimeWindow {
    ONE_MINUTE = '1m',
    TEN_MINUTES = '10m',
    ONE_HOUR = '1h',
    SIX_HOURS = '6h',
    TWENTY_FOUR_HOURS = '24h',
  }
  
  export const timeWindowOptions = [
    { label: '1 Minute', value: TimeWindow.ONE_MINUTE },
    { label: '10 Minutes', value: TimeWindow.TEN_MINUTES },
    { label: '1 Hour', value: TimeWindow.ONE_HOUR },
    { label: '6 Hours', value: TimeWindow.SIX_HOURS },
    { label: '24 Hours', value: TimeWindow.TWENTY_FOUR_HOURS },
  ];